import React from 'react';
import ColumnMenu from 'main/components/show/cuesheet/columnHeaderCell/itemColumnMenu.jsx';
import { DisplayForAdmin } from 'shared/components/misc/displayForRole.jsx';

/**
 * Item header cell
 *
 */
export default React.createClass({
  contextTypes: {
    router: React.PropTypes.object.isRequired,
    disableMenu: React.PropTypes.bool,
  },

  defaultPropTypes: {
    disableMenu: false,
  },

  displayName: 'ItemColumnHeaderCell',

  render() {
    let params = this.context.router.state.params,
      teamId = params.teamId,
      eventId = params.eventId;

    let columnMenuNode = this.props.disableMenu ? null : (
      <DisplayForAdmin teamId={teamId} eventId={eventId}>
        <div className="caret-right">
          <ColumnMenu {...this.props} />
        </div>
      </DisplayForAdmin>
    );

    return (
      <div className="cs-header-cell">
        Items
        {columnMenuNode}
      </div>
    );
  },
});
